import React from 'react';
import Routes from './routes';
import { hot } from 'react-hot-loader/root';

const App = () => <Routes />;

export default hot(App);
